import React from 'react';
import { AiEngine } from '@picsio/icons';
import { Icon as IconContainer } from '@picsio/ui';
import { useSelector } from 'react-redux';
import localization from '../../shared/strings';
import styles from './styles.module.scss';

const VisualSearchOnBanner = () => {
  const jobsStatus = useSelector((state) => state.notifications.jobsStatus);

  return (
    <div className={styles.onBanner}>
      <IconContainer size="md">
        <AiEngine className={styles.onBannerIcon} />
      </IconContainer>
      <span className={styles.onBannerText}>
        <Choose>
          <When condition={jobsStatus.embedding > 0}>
            {localization.VISUAL_SEARCH_BANNER.SEARCH_IS_ON_INDEXING(jobsStatus.embedding)}
          </When>
          <Otherwise>
            {localization.VISUAL_SEARCH_BANNER.SEARCH_IS_ON}
          </Otherwise>
        </Choose>
      </span>
    </div>
  );
};

export default VisualSearchOnBanner;
